module.exports = __webpack_public_path__ + "img/local_florist.0207b80c.svg";